exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".login-page-body {\r\n    min-height: 680px;\r\n    height: 100%;\r\n    /*background:  center 74px no-repeat fixed,linear-gradient(165deg,rgba(1,137,173,0) 0,rgba(1,137,173,0) 8%,#0189ad 40%,#0189ad 57%,rgba(1,137,173,0) 92%,rgba(1,137,173,0) 100%),#003d76;*/\r\n    background-size: cover;\r\n    background-attachment: fixed;\r\n    background-position: center bottom;\r\n}\r\n\r\n\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./ClientApp/app/app.component.css
// module id = 322
// module chunks = 3